export default __webpack_public_path__ + "img/75.5eed62f.svg";